import { render, staticRenderFns } from "./BasePopover.vue?vue&type=template&id=1a0e0a89&"
import script from "./BasePopover.vue?vue&type=script&lang=js&"
export * from "./BasePopover.vue?vue&type=script&lang=js&"
import style0 from "./BasePopover.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports